export default {
    RecACE:"RecACE",
    FIRSTRec:"FIRSTRec",
    User: "ユーザー管理",
    Permission:"権限管理",
    Device:"デバイス管理",
    Record:"録音音声一覧",
    Account:"アカウント管理",
}